import Axios, { REQUEST_METHOD } from "../axios";

/**
 * Fetch the quarterly CFO dashboard data
 */
export async function apiFetchOutStandingRewardPointsBal() {
  return Axios.fetch({
    url: "/users/outstanding-points-bal-liabilities", 
    method: REQUEST_METHOD.GET,
  });
}

export default {
  apiFetchOutStandingRewardPointsBal,
};
